
import { Component, Emit, Prop, Ref } from 'nuxt-property-decorator';
import { TiptapEditor } from '../tiptap';
import { TiptapExtension } from '../../types';
import AbstractInput from './abstractInput';
import { Collapsible } from '../layout';

@Component({
  components: {
    TiptapEditor,
    Collapsible,
  },
})
export default class RichTextEditor extends AbstractInput {
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  @Emit() input(_value: string) {}

  @Ref() tiptapEditor?: TiptapEditor;

  wordCount = 0;

  get inputClassNames() {
    return {
      '-destructive': this.validationErrors,
    };
  }

  get extensions() {
    const extensions: TiptapExtension[] = [];

    if (this.field.isBasicStylesAllowed) {
      extensions.push(
        TiptapExtension.Bold,
        TiptapExtension.Italic,
        TiptapExtension.Underline,
        TiptapExtension.Subscript,
        TiptapExtension.Superscript,
        TiptapExtension.Link,
      );
    }

    if (this.field.maxWords) {
      extensions.push(TiptapExtension.WordCount);
    }

    return extensions;
  }

  mounted() {
    this.updateWordCount();
  }

  public async onInput(value: string) {
    this.updateWordCount();

    // Ignore any kind of words validation if maxWords is 0
    if (this.field.maxWords > 0 && this.wordCount > this.field.maxWords) {
      this.$validator.errors.add({
        id: this.field.id,
        field: this.field.id,
        msg: this.$t('validation.rte_max_length') as string,
      });
    } else if (this.validationErrors) {
      // Remove rte_max_length message
      this.$validator.errors.removeById(this.field.id);
      // Trigger native validations
      await this.$validator.validate(this.field.id);
    }

    this.input(value);
  }

  public async onBlur() {
    // Preserve max words validation error
    if (this.field.maxWords > 0 && this.wordCount > this.field.maxWords) {
      return;
    }

    // Trigger native validations on blur
    await this.$validator.validate(this.field.id);
  }

  get errorTextId(): string {
    return `${this.field.id}-error`;
  }

  public updateWordCount() {
    if (!this.field.maxWords) return;
    this.wordCount = this.tiptapEditor?.editor?.storage.characterCount.words();
  }
}
